import { render, staticRenderFns } from "./block-list.vue?vue&type=template&id=05e47bbe&scoped=true&"
import script from "./block-list.vue?vue&type=script&lang=ts&setup=true&"
export * from "./block-list.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./block-list.vue?vue&type=style&index=0&id=05e47bbe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e47bbe",
  null
  
)

/* custom blocks */
import block0 from "./block-list.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports